import * as React from 'react';

var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.522 3.559V2.5M7.757 7.794H6.698M18.346 7.794h-1.06M9.346 4.618l-.75-.749M15.699 4.618l.748-.749M9.25 12.387V20.5M14.67 12.387h2.247a2.13 2.13 0 0 1 2.08 2.587l-.849 3.854a2.13 2.13 0 0 1-2.08 1.672",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.068 20.5h-9.8a1.065 1.065 0 0 1-1.065-1.065v-5.984a1.065 1.065 0 0 1 1.065-1.065H9.26",
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.669 12.387V9.43a1.42 1.42 0 0 0-.785-1.27l-.36-.18a1.775 1.775 0 0 0-2.366.767L9.26 12.387",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgThumbsUp as default };
//# sourceMappingURL=thumbs-up.svg.js.map
